import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel, Table, Input, DatePicker, Modal, Card, Row, Col, message, Image, Checkbox, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Meta } = Card;
const AdminCourseList = () => {
    const navigate = useNavigate();
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={8}>
                    <Card
                        title="Default size card"
                        bordered
                    >
                        <Row justify={'end'} gutter={[8, 8]}>
                            <Col span={24}>授課時間：</Col>
                            <Col span={24}>授課教室：</Col>
                            <Col>
                                <Button style={{ backgroundColor: '#73FAC9', display: "inline-flex", alignItems: "center" }} onClick={e => navigate('/cramSchool/admin/CourseOutlineManage')}>前往課程</Button>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>
    )
}
export default AdminCourseList;